<template>
  <div class="app">
    <AppHeader ref="AppHeader" />
    <div class="app-body">
      <Sidebar ref="Sidebar" />
      <main class="main">
        <!-- <p @focus="this.onfocus()"></p> -->
        <div v-if="!checkManage" class="ver-str">
          <img :src="'static/img/logo_nav_gray.png'" alt="1on1navi">
          <br>for<br><span>{{checkCompanyName}}</span><br>{{checkAppVersion}}<br>
        </div>
        <router-view :ready-for-state="checkForState"></router-view>
        <transition name="modal">
          <tutorial v-if="tutorialShow" @end-tutorial="endTutorial"/>
        </transition>
        <transition name="modal">
          <div v-if="agreementModal" class="terms modal-mask">
            <div class="modal-wrapper">
              <div class="modal-container" v-if="!licenseAgreement">
                <div class="terms-body">
                  <web-view-terms-ja v-if="checkLanguage === 'ja'"/>
                  <web-view-terms-en v-else-if="checkLanguage === 'en'" />
                  <web-view-terms-zh v-else-if="checkLanguage === 'zh_tr'" />
                </div>
                <div class="agreemnt-btns">
                  <button type="button" class="btn btn-danger block m-b" @click="rejectTerms">{{ $t('disagreeBtnTitle') }}</button>
                  <button type="button" class="btn btn-success block m-b" @click="agreeTerms">{{ $t('agreeBtnTitle') }}</button>
                </div>
                <b-button-group>
                  <b-button @click="changeLanguage('ja')"><img class="flag" :src="'static/img/flag/flag_japan.png'" alt="">日本語 <small>{{$t('transLanguage.ja')}}</small></b-button>
                  <b-button @click="changeLanguage('en')"><img class="flag" :src="'static/img/flag/flag_usa.png'" alt="">English <small>{{$t('transLanguage.en')}}</small></b-button>
                  <b-button @click="changeLanguage('zh_tr')"><img  class="flag" :src="'static/img/flag/flag_china.png'" alt="">繁體中文 <small>{{$t('transLanguage.ch')}}</small></b-button>
                </b-button-group>
              </div>
            </div>
          </div>
        </transition>
      </main>
    </div>
  </div>
</template>
<script src="../js/common.js"></script>
<script>
import { Header as AppHeader, Sidebar } from '../components/'
import { mapGetters, mapActions } from 'vuex'
import { willysm, about, i18n, transLanguage, routeRegistPath, licenseAgreement } from '@/main'
import WebViewTermsJa from '@/views/_webview/WebViewTermsJA'
import WebViewTermsEn from '@/views/_webview/WebViewTermsEN'
import WebViewTermsZh from '@/views/_webview/WebViewTermsZH'
import Tutorial from '@/components/Tutorial'

export default {
  name: 'full',
  components: {
    AppHeader,
    Sidebar,
    WebViewTermsJa,
    WebViewTermsEn,
    WebViewTermsZh,
    Tutorial
  },
  methods: {
    ...mapActions({
      setCurrentTimestamp: 'SET_CURRENT_TIMESTAMP',
      removeTermsFlag: 'removeTermsFlag',
      removeTutorialFlag: 'removeTutorialFlag',
      excuteBind: 'excuteBind'
    }),
    ...mapActions('profiles/', {
      removeUser: 'REMOVE_USER'
    }),
    agreeTerms: function () {
      this.agreementModal = false
      this.checkForState = false
      this.removeTermsFlag()
    },
    rejectTerms: function () {
      console.log('delete targit uid', this.$firebase.auth().currentUser.uid)
      let targerUid = this.$firebase.auth().currentUser.uid
      this.removeUser(targerUid)
      // ここ ユーザーを削除してからサインアウトする
      this.$firebase.auth().currentUser.delete()
        .then(() => {
          console.log('user deleted')
          this.$firebase.auth().signOut()
        })
        .then((user) => {
          console.log('LogOut: ', user)
          this.$router.replace({ name: 'Login' })
        })
    },
    changeLanguage: function (locale) {
      transLanguage(locale)
      try {
        if (window.localStorage) {
          localStorage.setItem('language', locale)
        } else {
          // alert('言語切り替えをするには、ブラウザ設定でLocalStorageを有効にする必要があります')
        }
      } catch (e) {
        // alert('言語切り替えをするには、ブラウザ設定でLocalStorageを有効にする必要があります')
        console.log('storage error::', e)
      }
    },
    endTutorial: function () {
      this.tutorialShow = false
      this.removeTutorialFlag()
      this.excuteBind(this.getUserId)
    },
    isShowForceUpdateSweetAlert (versionCheck) {
      return versionCheck && versionCheck.web && versionCheck.web.latest && this.checkAppVersion !== '' && versionCheck.web.latest !== this.checkAppVersion && versionCheck.web.forceUpdate
    }
  },
  beforeMount: function () {
    if (this.getCurrentUser && this.getCurrentUser.showTerms) {
      console.log('beforeMount: agreementModal')
      this.agreementModal = true
    }
  },
  mounted: function () {
    console.log('Full.vue:mounted:')
    console.log('Full.vue:mounted:checkForState', this.checkForState)
    this.$refs.Sidebar.changeNavActive(this.name, this.list[1].name)
    // this.$router.push({ name: target })
    if (this.getCurrentUser && this.getCurrentUser.userInfo && this.getCurrentUser.showTerms) {
      console.log('this.getCurrentUser && this.getCurrentUser.userInfo && this.getCurrentUser.showTerms) {')
      this.agreementModal = true
    } else if (this.$route.params.regist && this.getCurrentUser.showTerms) {
      console.log('新規登録したな！利用規約に同意しろ！ } else if (this.$route.params.regist) {')
      this.agreementModal = true
    } else if (this.$route.params.registed && this.getCurrentUser.showTutorial && !this.getCurrentUser.showTerms) {
      console.log('you not show tutorial yet.')
      this.tutorialShow = true
    } else if (this.getCurrentUser.showTutorial && !this.getCurrentUser.showTerms && this.getCurrentUserInfo.userName) {
      console.log('you not show tutorial yet.')
      this.tutorialShow = true
    }
    if (willysm.enabled || licenseAgreement) {
      this.agreeTerms()
    }
  },
  updated: function () {
    console.log('Full.vue:updated:checkForState', this.checkForState)
    console.log('Full.vue:updated:this.name', this.name)
    let componentName
    if (this.name === 'ProfileRegist') componentName = true
    else componentName = false
    console.log('this.$route.params:::::::::::::::', this.$route.params)
    if (this.$refs.AppHeader && this.$refs.Sidebar) {
      this.$refs.AppHeader.onChangeHidden(componentName)
      this.$refs.Sidebar.onChangeHidden(componentName)
    }
    console.log('this.getCurrentUserInfo in full', this.getCurrentUserInfo)
    if (!componentName && this.getUserId && this.getCurrentUserInfo && !this.getCurrentUserInfo.userName && this.getCurrentUserInfo.userEmail) {
      console.log('this.getCurrentUserInfo in full', this.getCurrentUserInfo, this.getCurrentUserInfo.userEmail)
      this.$router.push({ name: 'ProfileRegist' })
    } else if (!componentName && this.getUserId && this.getCurrentUserInfo && !this.getCurrentUserInfo.userEmail) {
      console.log('!componentName && this.getUserId && this.getCurrentUserInfo && !this.getCurrentUserInfo.userEmail')
      this.$firebase.auth().signOut().then(
        this.$router.push({ name: 'Login' })
      )
    } else if (!componentName && this.getUserId && !this.getCurrentUser.userInfo) {
      console.log({componentName: componentName, getUserID: this.getUserId, getCurrentUserInfo: this.getCurrentUser.userInfo})
      // this.$firebase.auth().signOut().then(
      //   this.$router.push({ name: 'Login' })
      // )
    } else if (this.getCurrentUser && this.getCurrentUser.userInfo && this.getCurrentUser.showTerms) {
      console.log('updated: } else if (this.getCurrentUser && this.getCurrentUser.userInfo && this.getCurrentUser.showTerms) {')
      this.agreementModal = true
      if (willysm.enabled || licenseAgreement) {
        this.agreeTerms()
      }
      console.log('agreementModal::', this.agreementModal)
    } else if (this.$route.params.registed && this.getCurrentUser.showTutorial && !this.getCurrentUser.showTerms && this.name === routeRegistPath) {
      console.log('you not show tutorial yet.')
      this.tutorialShow = true
    } else if (this.getCurrentUser.showTutorial && !this.getCurrentUser.showTerms && this.getCurrentUserInfo.userName && this.name === routeRegistPath) {
      console.log('you not show tutorial yet.')
      this.tutorialShow = true
    }
    console.log('name::', this.name)
    console.log('list::', this.list)
    console.log('getNavList::', this.getNavList)
  },
  created: function () {
    console.log('Full.vue:created:checkForState', this.checkForState)
    this.$firebase.auth().onIdTokenChanged(user => {
      this.checkForState = !!user
      if (user) {
        console.log('Full.vue:created:onIdTokenChanged:', user)
        user && user.getIdTokenResult().then(
          (idTokenResult) => {
            console.log('Full.vue:idTokenResult:', idTokenResult)
            if (idTokenResult && idTokenResult.claims) {
              if (idTokenResult.claims.unavailable) {
                console.log('Full.vue: idTokenResult unavailable')
                this.$swal({
                  title: this.$t('noticeUnavailable'),
                  type: 'warning'
                })
                this.$firebase.auth().signOut()
                this.$router.replace({ name: 'Login' })
              }
              if (idTokenResult.claims.showTerms) {
                console.log('Full.vue: idTokenResult showTerms')
                this.agreementModal = true
                if (willysm.enabled || licenseAgreement) {
                  this.agreeTerms()
                }
              }
              if (idTokenResult.claims.showTutorial && this.name === routeRegistPath) {
                console.log('Full.vue: idTokenResult showTutorial')
                this.tutorialShow = true
              }
            }
          })
      } else {
        this.$firebase.auth().signOut()
        this.$router.replace({ name: 'Login' })
      }
    })
  },
  data () {
    return {
      currentTimestamp: '',
      company: about.companyName,
      readyForState: false,
      agreementModal: false,
      tutorialShow: false,
      licenseAgreement: licenseAgreement
    }
  },
  computed: {
    ...mapGetters([
      'getUserId',
      'getCurrentUserInfo',
      'getCurrentUser'
    ]),
    ...mapGetters('_meta/', [
      'getMetaVersionCheck'
    ]),
    checkCompanyName () {
      if (about && about.companyName) return about.companyName
      else return ''
    },
    checkAppVersion () {
      if (about && about.appVersion) return about.appVersion
      else return ''
    },
    checkForState: {
      get: function () {
        console.log('checkForState:get')
        return this.readyForState
      },
      set: function (val) {
        console.log('checkForState:set')
        this.readyForState = val
      }
    },
    name () {
      return this.$route.name
    },
    list () {
      return this.$route.matched
    },
    getNavList () {
      return this.nav
    },
    checkLanguage () {
      return i18n.locale
    },
    checkManage () {
      if (this.name.match(/Manage/) ||
      this.name.match(/Report/) ||
      this.name.match(/Terms/) ||
      this.name.match(/Help/) ||
      this.name.match(/Reset/) ||
      this.name.match(/Network/)) return true
      else return false
    }
  },
  watch: {
    '$route': function () {
      this.currentTimestamp = new Date().getTime() / 1000
      // console.log('on focus in fullview!!')
      this.setCurrentTimestamp(this.currentTimestamp)
      this.$refs.Sidebar.changeNavActive(this.name, this.list[1].name)
    },
    getCurrentUser: function () {
      if (this.getCurrentUser) {
        console.log('Full.vue:watch:getCurrentUser', this.getCurrentUser)
        if (this.getCurrentUser.showTerms) {
          console.log('getCurrentUser: agreementModal')
          this.agreementModal = true
          // } else if (this.getCurrentUser.userInfo) {
          //   this.readyForState = false
          if (willysm.enabled || licenseAgreement) {
            this.agreeTerms()
          }
        }
      }
    },
    getMetaVersionCheck (versionCheck) {
      console.log('watch:::trace:::getMetaVersionCheck', versionCheck, this.isShowForceUpdateSweetAlert(versionCheck))
      if (this.isShowForceUpdateSweetAlert(versionCheck)) {
        const newVersionReleasedNoticeMessage = this.$t('noticeNewVersionReleased')
        const newVersionReleasedNoticeMessageForShow = newVersionReleasedNoticeMessage.replace('{$version}', versionCheck.web.latest)
        this.$swal({
          title: newVersionReleasedNoticeMessageForShow,
          type: 'warning',
          showCancelButton: false,
          cancelButtonColor: '#f64846',
          confirmButtonClass: 'btn btn-success',
          cancelButtonClass: 'btn btn-danger',
          reverseButtons: false,
          animation: false,
          customClass: 'animated fadeInUp',
          // customClass: 'animated flipInX',
          width: '35rem',
          position: 'center',
          // toast: true,
          allowOutsideClick: false,
          padding: '2rem'
          // timer: 5000
        }).then((result) => {
          if (result.value) {
            location.reload()
          }
        })
      }
    }
  }
}
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.terms {
  .modal-mask {
    position: fixed;
    z-index: 9998;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, .5);
    display: table;
    transition: opacity .3s ease;
  }

  .modal-wrapper {
    display: table-cell;
    vertical-align: middle;
  }

  .modal-container {
    position: relative;
    margin: auto;
    z-index: 9999;
    width: 60%;
    height: auto;
    padding: 20px 30px;
    background-color: white;
    border-radius: 2px;
    transition: all .3s ease;
    font-family: Helvetica, Arial, sans-serif;
  }

  .modal-header h3 {
    margin-top: 0;
    color: #42b983;
  }

  .modal-body {
    margin: 20px 0;
  }

  .modal-default-button {
    float: right;
  }

  .modal-enter {
    opacity: 0;
  }

  .modal-leave-active {
    opacity: 0;
  }

  .modal-enter .modal-container,
  .modal-leave-active .modal-container {
    -webkit-transform: scale(1.1);
    transform: scale(1.1);
  }
}

.terms-body{
  width: 100%;
  height: 500px;
  border: solid 5px #c6d4d8;
  border-radius: 5px;
  overflow: auto;
}
.terms-body >>> .app { overflow: visible; }

.agreemnt-btns{
  position:relative;
  text-align: center;
  width: 100%;
  height: auto;
	margin: 0 auto;
  margin-top: 10px
}

.agreemnt-btns button {
  display: inline-block;
}
img.flag {
  width: 2rem;
}
.btn-group {
  display: flex;
  justify-content: space-around;
  display: flex;
  justify-content: space-around;
  margin-top: 3rem;
}
</style>



// WEBPACK FOOTER //
// src/containers/Full.vue